import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';
import { HandlebarNumber } from '../HandlebarNumber';

export const createNumberLiteral = (value: HandlebarNumber) => ({
  type: NodeType.NumberLiteral,
  loc,
  value: value.toString(),
  original: value.toString(),
});
